import React from 'react';
interface JUNOCheckboxProps {
  checked: boolean;
  name: string;
  text: string;
  value: string;
  stateChange: (checked: boolean) => void;
  disabled?: boolean;
}
const JUNOCheckbox: React.FC<JUNOCheckboxProps> = ({ checked, name, text, value, stateChange, disabled }) => {
  return (
    <div className="JUNOCheckbox">
      <label>
        <input
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          onChange={event => {
            stateChange(event.target.checked);
          }}
          disabled={disabled}
        />
        <span className="checkmark_span"></span>
        <span className="checkmark_text">{text}</span>
      </label>
    </div>
  );
};
export default JUNOCheckbox;
